import { axiosService } from "../axios.service";
import { urls } from "../../constants";

export const ADMIN_KEY = '__admin';

export const siteConfigService = {
    getAdminConfig: () =>
        axiosService.get(urls.siteConfig.adminConfig).then(v => v.data),

    saveAdminConfig: (adminConfig) =>
        axiosService.post(urls.siteConfig.adminConfig, { adminConfig }).then(v => v.data),

    getAllSections: () =>
        axiosService.get(urls.siteConfig.sections).then(v => v.data),

    saveSection: (key, data) =>
        axiosService.post(urls.siteConfig.sections, { key, data }).then(v => v.data),

    getHistory: (key) =>
        axiosService.get(`${urls.siteConfig.history}?key=${encodeURIComponent(key)}`).then(v => v.data),

    updateHistoryName: (id, name) =>
        axiosService.patch(`${urls.siteConfig.history}/${id}`, { name }).then(v => v.data),

    deleteHistory: (id) =>
        axiosService.destroy(`${urls.siteConfig.history}/${id}`).then(v => v.data),

    clearHistory: (key) =>
        axiosService.destroy(`${urls.siteConfig.history}?key=${encodeURIComponent(key)}`).then(v => v.data),

    undoSection: (key) =>
        axiosService.post(urls.siteConfig.undo, { key }).then(v => v.data),

    resetToHistory: (key, historyId) =>
        axiosService.post(urls.siteConfig.reset, { key, historyId }).then(v => v.data),

    // Uploads a builder image (logo/hero/etc.) to the same GCS bucket every
    // other admin upload (dishes, pack categories, ...) uses — returns a
    // real, permanent public URL, never a base64 data: URI stored in config.
    uploadImage: (file) => {
        const formData = new FormData();
        formData.append("file", file);
        return axiosService.post(urls.siteConfig.uploadImage, formData).then(v => v.data);
    },
};

// Backward-compat alias used by AppInitializer
export const builderService = {
    getConfig: () =>
        siteConfigService.getAdminConfig().then(adminConfig => ({ adminConfig: adminConfig || null })),
};
